import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import Raven from 'raven-js';
import { Component } from 'react';

// Define the state for the ErrorBoundary component
import { jsx as _jsx } from "react/jsx-runtime";
// HOC to wrap a component with error boundary functionality
const withErrorBoundary = WrappedComponent => {
  return class ErrorBoundary extends Component {
    constructor(props) {
      super(props);
      this.state = {
        hasError: false
      };
    }
    static getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI
      return {
        hasError: true
      };
    }
    componentDidCatch(error) {
      // You can log the error to an error reporting service here
      Raven.captureException(new Error('[Copilot Preview ErrorBoundary]', error));
    }
    render() {
      if (this.state.hasError) {
        // Render fallback UI if error is caught
        return /*#__PURE__*/_jsx(ErrorMessage, {
          type: "badRequest",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "aiAddonCopilotPreview.components.copilotPreview.error.title"
          }),
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "aiAddonCopilotPreview.components.copilotPreview.error.message"
            })
          })
        });
      }

      // Render the wrapped component with all its props
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }
  };
};
export default withErrorBoundary;